import { useContext } from "react";
import { useCommandState } from "cmdk";

import { SelectContentContext, SelectPinnedContext, useSelectContext } from "../SelectContext";
import { SelectItem } from "../SelectItem";

/**
 * While the search is empty, lists any selected value that none of the rendered items carries —
 * typically a selection that has dropped out of server-side results — so it stays visible and can
 * be unselected.
 */
export const SelectPinnedItems = () => {
  const { selectedValues, isRendered, labelFor, getItem } = useSelectContext();
  const hideSelectedItems = useContext(SelectContentContext)?.hideSelectedItems ?? false;
  const hasSearch = useCommandState((state) => state.search.length > 0);
  if (hideSelectedItems || hasSearch) return null;

  return (
    <SelectPinnedContext.Provider value>
      {selectedValues.map((selectedValue) =>
        isRendered(selectedValue) ? null : (
          <SelectItem
            key={selectedValue}
            value={selectedValue}
            textValue={getItem(selectedValue)?.textValue || selectedValue}
            forceMount
          >
            {labelFor(selectedValue)}
          </SelectItem>
        )
      )}
    </SelectPinnedContext.Provider>
  );
};
